<template>
  <div class="contact_container">
    <js-banner
      title="联系我们"
    />
    <div class="contact_wrapper">
      <img src="/img/contact/contact.jpg" alt="联系我们">
      <div class="contact">
        <div class="wrapper">
          <i class="el-icon-map-location"></i>
          地址：中国上海市虹口区东大名路908号金岸大厦十三层
        </div>
        <div class="wrapper">
          <i class="el-icon-phone-outline"></i>
          电话：021-65957777
        </div>
        <div class="wrapper">
          <i class="el-icon-printer"></i>
          传真：021-65956666、65959999
        </div>
        <div class="wrapper">
          <i class="el-icon-postcard"></i>
          邮编：200082
        </div>
        <router-link
          class="wrapper branch"
          tag="div"
          to="/about/branch"
        >
          <i class="el-icon-position"></i>
          点击查看各地服务网点
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import JsBanner from '@/packages/JsBanner'
export default {
  name: 'contact',
  components: {
    JsBanner
  }
}
</script>

<style lang="scss" scoped>
.contact_wrapper {
  max-width: 1200px;
  margin: 50px auto;
  display: flex;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 12px 2px rgba(0, 0, 0, .2);
  img {
    height: 200px;
  }
  .contact {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-left: 20px;
    font-size: 20px;
    .branch {
      &:hover {
        cursor: pointer;
        color: rgb(1, 161, 235);
      }
    }
  }
}
</style>
